{
  "title": "Tasha's Hideous Laughter",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level enchantment",
  "level": 1,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "V, S, M (tiny tarts and a feather that is waved in the air)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "A creature of your choice that you can see within range perceives everything as hilariously funny and falls into fits of laughter if this spell affects it. The target must succeed on a Wisdom saving throw or fall prone, becoming incapacitated and unable to stand up for the duration. A creature with an Intelligence score of 4 or less isn’t affected.",
    "At the end of each of its turns, and each time it takes damage, the target can make another Wisdom saving throw. The target has advantage on the saving throw if it’s triggered by damage. On a success, the spell ends."
  ],
  "spellLists": ["bard", "arcane-trickster", "wizard"]
}
